module.exports = __webpack_public_path__ + "assets/47f255af101f94d9807443b698b8ae3e.png";